import { Icon, IconButton } from '@chakra-ui/react'
import { faCheckCircle, faPlusCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react'

export const AddButton = ({ alreadyAdded, onClick }: { alreadyAdded: boolean, onClick: () => Promise<any> }) => {
  const [loading, setLoading] = useState(false)

  return alreadyAdded ?
    <Icon as={FontAwesomeIcon} color='green.600' icon={faCheckCircle} size='lg' />
    :
    <IconButton
      size="sm"
      variant="ghost"
      onClick={() => {
        setLoading(true)
        onClick().finally(() => setLoading(false))
      }}
      isLoading={loading} aria-label='Add' icon={<Icon as={FontAwesomeIcon} icon={faPlusCircle} size='xl' />}>
    </IconButton>
}